<div [formGroup]="parentForm">
  <div [formGroupName]="authControlKey">
    <div
      fxLayout="row wrap"
      fxLayoutGap="20px grid"
      class="u-margin-bottom-3"
      *ngIf="this.provider==='GiveX'"
    >
      <div fxFlex="100" fxFlex.gt-sm="40" fxLayoutAlign="start center">
        {{
        "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.allow_to_sale_topup"
        | translate }}
      </div>
      <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
        <mat-slide-toggle
          id="matSelectToggleAllowSaleTopupGiftCard"
          formControlName="allowSaleTopupGiftCard"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutGap="20px grid"
      class="u-margin-bottom-3"
      *ngIf="this.provider==='GiveX'"
    >
      <div fxFlex="100" fxFlex.gt-sm="40" fxLayoutAlign="start center">
        {{
        "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.expiry_set_by_user"
        | translate }}
      </div>
      <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
        <mat-slide-toggle
          id="matSelectToggleExpirySetByUser"
          formControlName="expirySetByUser"
          (change)="changeExpirySetByUser()"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid" *ngIf="enableExpiryDate()">
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label for="matFrmFieldDefaultExpiryDays" style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.default_expiry_days"
          | translate }}<span class="required-astrik" *ngIf="isRequired('expiryDate')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldDefaultExpiryDays" style="padding-left: 10pt;">
          <input
            id="txtDefaultExpiryDays"
            type="number"
            numbersOnly="true"
            formControlName="expiryDate"
            matInput
            maxlength="20"
          />
        </mat-form-field>
      </div>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutGap="20px grid"
      class="u-margin-bottom-3"
      *ngIf="this.provider==='GiveX' || this.provider==='Netsuite'"
    >
      <div fxFlex="100" fxFlex.gt-sm="40" fxLayoutAlign="start center">
        {{
        "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.flexiblecard_allowed"
        | translate }}
      </div>
      <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
        <mat-slide-toggle
          id="matSelectToggleFlexibleCard"
          formControlName="flexibleCardAllowed"
          (change)="changeFlexibleCardAllowed()"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid" *ngIf="enableFlexibleCard()">
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label for="matFrmFieldCardPrefix" style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.card_prefix"
          | translate }}<span class="required-astrik" *ngIf="isRequired('cardPrefix')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldCardPrefix" style="padding-left: 10pt;">
          <input
            id="txtCardPrefix"
            type="text"
            formControlName="cardPrefix"
            matInput
            maxlength="20"
          />
        </mat-form-field>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label for="matFrmFieldMinimumValue" style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.minimum_value"
          | translate }}<span class="required-astrik" *ngIf="isRequired('minimumValue')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldMinimumValue" style="padding-left: 10pt;">
          <input
            id="txtMinimumValue"
            formControlName="minimumValue"
            matInput
            maxlength="20"
            appTwoDigitDecimaNumber
          />
        </mat-form-field>
      </div>
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label for="matFrmFieldMaximumValue" style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.maximum_value"
          | translate }}<span class="required-astrik" *ngIf="isRequired('maximumValue')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldMaximumValue" style="padding-left: 10pt;">
          <input
            id="txtMaximumValue"
            type="number"
            numbersOnly="true"
            formControlName="maximumValue"
            matInput
            maxlength="20"
          />
        </mat-form-field>
      </div>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutGap="20px grid"
      class="u-margin-bottom-3"
      *ngIf="this.provider==='GiveX' || this.provider==='Netsuite'"
    >
      <div fxFlex="100" fxFlex.gt-sm="40" fxLayoutAlign="start center">
        {{
        "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.extra_slip_for_sale_of_new_GC"
        | translate }}
      </div>
      <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
        <mat-slide-toggle id="matSelectToggleSaleSlip" formControlName="extraSlipForSaleOfNewGC">
        </mat-slide-toggle>
      </div>
    </div>
    <div
      fxLayout="row wrap"
      fxLayoutGap="20px grid"
      class="u-margin-bottom-3"
      *ngIf="this.provider==='GiveX' || this.provider==='Netsuite'"
    >
      <div fxFlex="100" fxFlex.gt-sm="40" fxLayoutAlign="start center">
        {{
        "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.include_GC_in_calculation_of_transaction_promotion_discount"
        | translate }}
      </div>
      <div fxFlex="100" fxFlex.gt-sm="25" fxLayoutAlign="start center">
        <mat-slide-toggle
          id="matSelectToggleTransactionCaluculation"
          formControlName="includeGCInCalculationOfTransactionPromotionOrDiscount"
        >
        </mat-slide-toggle>
      </div>
      <!-- toggle for multiple gift card -->
      <div
        *ngIf="this.provider == 'GiveX'"
        fxFlex="100"
        fxFlex.gt-sm="40"
        fxLayoutAlign="start center"
      >
        {{
        "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.use_multiple_giftcard"
        | translate }}
      </div>
      <div
        *ngIf="this.provider == 'GiveX'"
        fxFlex="100"
        fxFlex.gt-sm="25"
        fxLayoutAlign="start center"
      >
        <mat-slide-toggle
          id="matSelectToggleMultipleGiftCard"
          formControlName="useMultipleGiftCard"
        >
        </mat-slide-toggle>
      </div>
    </div>
    <div *ngIf="this.provider !=='Paraspar'" fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label for="matFrmFieldSellGiftCardSKU" style="text-align: left;width: 150pt;">
          {{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.sell_gift_card_sku"
          | translate }}
          <span class="required-astrik" *ngIf="isRequired('giftCardSKU')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldSellGiftCardSKU" style="padding-left: 10pt;">
          <input id="txtSellGiftCardSKU" formControlName="giftCardSKU" matInput maxlength="500" />
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid" *ngIf="enableMaximumAmount()">
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.maximum_amount"
          | translate }}<span class="required-astrik" *ngIf="isRequired('maximumAmount')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldMaximumAmount" style="padding-left: 10pt;">
          <input
            id="txtMaximumAmount"
            type="number"
            formControlName="maximumAmount"
            numbersOnly="true"
            matInput
            maxlength="20"
          />
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid" *ngIf="enableMinimumAmount()">
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.minimum_amount"
          | translate }}<span class="required-astrik" *ngIf="isRequired('minimumAmount')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldMinimumAmount" style="padding-left: 10pt;">
          <input
            id="txtMinimumAmount"
            formControlName="minimumAmount"
            matInput
            maxlength="20"
            appTwoDigitDecimaNumber
          />
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.vat_code" |
          translate }}
        </mat-label>
        <mat-form-field id="matFrmFieldVatCode" style="padding-left: 10pt;">
          <input id="txtVatCode" formControlName="vatCode" matInput />
        </mat-form-field>
      </div>
    </div>
    <div fxLayout="row wrap" fxLayoutGap="20px grid">
      <div fxFlex="100" fxFlex.gt-sm="60">
        <mat-label style="text-align: left;width: 150pt;"
          >{{
          "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.vat_rate" |
          translate }}<span class="required-astrik" *ngIf="isRequired('vatRate')">*</span>
        </mat-label>
        <mat-form-field id="matFrmFieldVatRate" style="padding-left: 10pt;">
          <input
            id="txtVatRate"
            type="number"
            formControlName="vatRate"
            numbersOnly="true"
            matInput
            pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?"
            [required]="isRequired('vatRate')"
          />
        </mat-form-field>
      </div>
    </div>
    <div *ngIf="this.provider==='Paraspar'">
      <div fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="100" fxFlex.gt-sm="60">
          <mat-label style="text-align: left;width: 150pt;"
            >{{
            "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.maxPerBasket"
            | translate }}<span class="required-astrik" *ngIf="isRequired('maxPerBasket')">*</span>
          </mat-label>
          <mat-form-field id="matFrmFieldMaxPerBasket" style="padding-left: 10pt;">
            <input
              id="txtMaxPerBasket"
              type="number"
              formControlName="maxPerBasket"
              numbersOnly="true"
              matInput
              [required]="isRequired('maxPerBasket')"
            />
          </mat-form-field>
        </div>
      </div>
      <h4>{{ "module-assignment.giftCard.shippingDetails" | translate }}</h4>
      <div fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="100" fxFlex.gt-sm="60">
          <mat-label style="text-align: left;width: 150pt;"
            >{{
            "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.shippingCode"
            | translate }}<span class="required-astrik" *ngIf="isRequired('shippingCode')">*</span>
          </mat-label>
          <mat-form-field id="matFrmFieldShippingCode" style="padding-left: 10pt;">
            <input
              id="txtShippingCode"
              type="text"
              formControlName="shippingCode"
              matInput
              [required]="isRequired('shippingCode')"
            />
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="100" fxFlex.gt-sm="60">
          <mat-label style="text-align: left;width: 150pt;"
            >{{
            "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.shippingName"
            | translate }}<span class="required-astrik" *ngIf="isRequired('shippingName')">*</span>
          </mat-label>
          <mat-form-field id="matFrmFieldShippingName" style="padding-left: 10pt;">
            <input
              id="txtShippingName"
              type="text"
              formControlName="shippingName"
              matInput
              [required]="isRequired('shippingName')"
            />
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="100" fxFlex.gt-sm="60">
          <mat-label style="text-align: left;width: 150pt;"
            >{{
            "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.shippingVat"
            | translate }}<span class="required-astrik" *ngIf="isRequired('shippingVat')">*</span>
          </mat-label>
          <mat-form-field id="matFrmFieldShippingVat" style="padding-left: 10pt;">
            <input
              id="txtShippingVat"
              type="number"
              formControlName="shippingVat"
              numbersOnly="true"
              matInput
              [required]="isRequired('shippingVat')"
            />
          </mat-form-field>
        </div>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="20px grid">
        <div fxFlex="100" fxFlex.gt-sm="60">
          <mat-label style="text-align: left;width: 150pt;"
            >{{
            "organization.module_assignment_tab.tmc_setting_config_tab.gift_card_section_1.shippingTotal"
            | translate }}<span class="required-astrik" *ngIf="isRequired('shippingTotal')">*</span>
          </mat-label>
          <mat-form-field id="matFrmFieldShippingTotal" style="padding-left: 10pt;">
            <input
              id="txtShippingTotal"
              type="number"
              formControlName="shippingTotal"
              numbersOnly="true"
              matInput
              [required]="isRequired('shippingTotal')"
            />
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>
